import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { getIsUngatedForHelpDesk } from '../../selectors/gateSelectors';
import { useState } from 'react';
import MoveToInbox from 'conversations-thread-view/move-to-inbox/components/MoveToInbox';
import ThreadViewProvider from '../../thread-view/components/ThreadViewProvider';
//@ts-expect-error provider doesn't have types yet
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const __MoveToInboxWithProvider = provideThreadView(MoveToInbox);
const TicketWorkspaceDisagreementBanner = ({
  ticket,
  threadId
}) => {
  const [showMoveThreadPrompt, setShowMoveThreadPrompt] = useState(false);
  const isUngatedToHelpdesk = useSelector(getIsUngatedForHelpDesk);
  if (isUngatedToHelpdesk && ticket && ticket.defaultProperties.hs_in_helpdesk.value === 'true') {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIAlert, {
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'conversations-inbox-ui.banners.ticketWorkspaceDisagreement.title'
        }),
        closeable: false,
        children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'conversations-inbox-ui.banners.ticketWorkspaceDisagreement.moveCTA'
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            size: "small",
            use: "tertiary",
            onClick: () => setShowMoveThreadPrompt(true),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'conversations-inbox-ui.banners.ticketWorkspaceDisagreement.button'
            })
          })]
        })
      }), showMoveThreadPrompt && /*#__PURE__*/_jsx(ThreadViewProvider, {
        threadId: threadId,
        children: /*#__PURE__*/_jsx(__MoveToInboxWithProvider, {
          shouldShowHelpdesk: true,
          onConfirm: () => setShowMoveThreadPrompt(false),
          onReject: () => setShowMoveThreadPrompt(false)
        })
      })]
    });
  }
  return null;
};
export default TicketWorkspaceDisagreementBanner;
TicketWorkspaceDisagreementBanner.displayName = 'TicketWorkspaceDisagreementBanner';